// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvInput,
  AvRadioGroup,
} from 'availity-reactstrap-validation';

// Helpers
import {
  isDiff,
} from '@vroskus/library-helpers/dist/browser';

// Types
type $OptionalProps = {
  className?: string;
  onChange?: (value: null | string) => unknown;
  required?: boolean;
  value?: null | string;
};

type $Props = $OptionalProps & {
  labelFalse: string;
  labelTrue: string;
  name: string;
};

type $State = {
  value: null | string;
};

class InputYesNoView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    onChange: undefined,
    required: undefined,
    value: undefined,
  };

  constructor(props: $Props) {
    super(props);

    this.state = {
      value: props.value || null,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      value,
    } = this.props;

    if (isDiff(
      prevProps.value,
      value,
    )) {
      this.setState({
        value: value || null,
      });
    }
  }

  renderValue({
    label,
    type,
  }: {
    label: string;
    type: string;
  }) {
    const {
      name,
      onChange,
    } = this.props;
    const {
      value,
    } = this.state;

    const id = `${name}${type}`;

    return (
      <label
        className={'d-flex justify-content-start align-items-center mb-1 mr-2'}
        htmlFor={id}
      >
        <AvInput
          checked={value === type}
          id={id}
          onClick={() => {
            this.setState({
              value: type,
            });

            if (onChange) {
              onChange(type);
            }
          }}
          type={'radio'}
        />
        <span className={'fa fa-check'} />
        {label}
      </label>
    );
  }

  render() {
    const {
      className,
      labelFalse,
      labelTrue,
      name,
      required,
    } = this.props;
    const {
      value,
    } = this.state;

    return (
      <div className={`InputYesNo radio c-radio mb-3 ${className || ''}`}>
        <AvRadioGroup
          className={'pb-0'}
          inline
          name={`_${name}`}
          required={required === true && value === null}
          value={value}
        >
          <Row>
            <Col>
              {this.renderValue({
                label: labelTrue,
                type: 'true',
              })}
            </Col>
            <Col>
              {this.renderValue({
                label: labelFalse,
                type: 'false',
              })}
            </Col>
          </Row>
        </AvRadioGroup>
        <AvInput
          name={name}
          style={{
            display: 'none',
          }}
          value={value}
        />
      </div>
    );
  }
}

export default InputYesNoView;
